import { render, staticRenderFns } from "./RoleIndex.vue?vue&type=template&id=7cbb2b80&scoped=true&"
import script from "./RoleIndex.vue?vue&type=script&lang=js&"
export * from "./RoleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbb2b80",
  null
  
)

export default component.exports